<template>
<div class="content" v-loading="loading">
  <div class="header">
    <el-button @click="getCustomerExcel(1)">预览</el-button>
    <el-button @click="getCustomerExcel(0)">导出</el-button>
    <el-button @click="back">返回</el-button>
  </div>
  <div class="body">
    <el-descriptions :column="1" direction="vertical" border>
      <el-descriptions-item size="mini">
        <template slot="label">
          <span style="font-weight: bold;color: black;font-size: 18px;">入伙信息明细表</span>
        </template>
        <el-descriptions size="mini" :column="2" border :label-style="{width:'100px'}" :contentStyle="{maxWidth:'300px',wordBreak:'break-all'}">
          <el-descriptions-item label="房产信息">
            <el-input size="mini"
              class="c-input"
              placeholder=""
              v-model="where.house_name"
              clearable>
            </el-input>
          </el-descriptions-item>
          <el-descriptions-item label="入伙时间">
            <el-date-picker size="mini"
              style="width: 45%"
              v-model="where.join_start_date"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              clearable
              placeholder="选择开始时间">
            </el-date-picker>
            至
            <el-date-picker size="mini"
              style="width: 45%"
              v-model="where.join_end_date"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              clearable
              placeholder="选择结束时间">
            </el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="收楼时间">
            <el-date-picker size="mini"
              style="width: 45%"
              v-model="where.closing_start_date"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              clearable
              placeholder="选择开始时间">
            </el-date-picker>
            至
            <el-date-picker size="mini"
              style="width: 45%"
              v-model="where.closing_end_date"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              clearable
              placeholder="选择结束时间">
            </el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="是否收楼">
            <el-checkbox-group size="mini" v-model="where.is_repossession">
              <el-checkbox :label="0">未收</el-checkbox>
              <el-checkbox :label="1">已收</el-checkbox>
            </el-checkbox-group>
          </el-descriptions-item>
          <el-descriptions-item label="业主经理人">
            <el-input size="mini"
              class="c-input"
              placeholder=""
              v-model="where.owner_manager"
              clearable>
            </el-input>
          </el-descriptions-item>
          <el-descriptions-item label="物业经理人">
            <el-input size="mini"
              class="c-input"
              placeholder=""
              v-model="where.property_manager"
              clearable>
            </el-input>
          </el-descriptions-item>
          <el-descriptions-item label="销售经理人">
            <el-input size="mini"
              class="c-input"
              placeholder=""
              v-model="where.sales_manager"
              clearable>
            </el-input>
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions-item label="房产类型">
          <el-checkbox-group size="mini" v-model="where.house_type" style="width: 100%;">
            <el-checkbox label="1">住宅</el-checkbox>
            <el-checkbox label="2">车位</el-checkbox>
            <el-checkbox label="3">储藏室</el-checkbox>
            <el-checkbox label="4">商铺</el-checkbox>
            <el-checkbox label="5">写字楼</el-checkbox>
          </el-checkbox-group>
        </el-descriptions-item>
      </el-descriptions-item>
    </el-descriptions>
  </div>
  <ViewFile ref="ViewFile" />
</div>
</template>

<script>
import AppConfig from "../../../../config/AppConfig";
import ViewFile from "../../Common/ViewFile";

export default {
  name: "HouseMoveInfo",
  components: {ViewFile},
  inject:['ReportCustomer'],
  data(){
    return{
      where:{
        house_name:"",
        join_start_date:"",
        join_end_date:"",
        closing_start_date:"",
        closing_end_date:"",
        is_repossession:[],
        owner_manager:"",
        property_manager:"",
        sales_manager:"",
        project_id:0,
        house_type:['1','4','5'],
      },
      loading:false,
    }
  },
  mounted() {
    this.where.house_name=this.ReportCustomer.house_name;
    this.where.project_id=this.ReportCustomer.project_id;
  },
  methods:{
    back(){
      this.ReportCustomer.customerMenuIndex="CustomerMain";
    },
    getCustomerExcel(ready_type=1){
      const that=this;
      if(!that.where.house_name){
        that.$message.error('请选择项目/房产！')
        return false;
      }
      that.loading=true;
      let where=ERP.reJson(that.where)
      where.is_repossession=where.is_repossession.join(',');
      where.house_type=where.house_type.join(',');
      ERP.postRequest({
        url: "admin/HouseMoveInfo/getExcel",
        data: where
      }, res => {
        if (res.code) {
          if(ready_type===1){
            that.$refs.ViewFile.show({
              width: '90vw',
              height:'80vh',
              title:"预览文件",
              src:AppConfig.erp_server+res.data,
              download(){
                // TODO 下载文件逻辑
                window.open(AppConfig.erp_server+res.data)
              }
            })
          }else {
            window.open(AppConfig.erp_server+res.data);
          }
        }
        that.loading = false;
      })
    }
  },
  watch:{
    "ReportCustomer.house_name":function (n,o) {
      this.where.house_name=n;
      this.where.project_id=this.ReportCustomer.project_id;
    }
  }

}
</script>

<style lang="scss" scoped>
.content{
  .header{
    display: flex;
    flex-direction: row;
  }
  .body{
    margin-top: 10px;

    .c-input{
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/components/HouseMoveInfo.vue